import { PORTS } from "../../../../config/modulePort";
import api from "../../../../services/Api";

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
}

const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || ""; // Default to an empty string or another default value

const USER_MGMT_URL = process.env.REACT_APP_USER_MGMT_URL || "";

const getTeamsData = async (userData: any): Promise<any> => {
  try {
    const getTeamAPI = api(PICKLIST_URL); // Pass the port dynamically
    const response = await getTeamAPI.post<ApiResponse<any>>(
      "/api/team/search",
      userData,
    );
    const updatedResult = response.data?.result.map((user: any) => ({
      ...user,
      actions: { Edit: "Edit" }, // Add the actions field to each user
    }));

    return updatedResult;
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw new Error("Failed to fetch the team data. Please try again.");
  }
};

const getHODName = async (): Promise<any> => {
  try {
    const getTeamAPI = api(USER_MGMT_URL);
    const response = await getTeamAPI.get(`/api/user/userlookup/gethods`);
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching HOD Name:", error);
    throw new Error("Unable to fetch HOD Name. Please try again later.");
  }
};

const getEmployeeNameforTeam = async (): Promise<any> => {
  try {
    const getTeamAPI = api(USER_MGMT_URL);
    const response = await getTeamAPI.get(
      `/api/user/userlookup/getteammembers`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching HOD Name:", error);
    throw new Error("Unable to fetch HOD Name. Please try again later.");
  }
};

const getEmployeeNameforTeamByCaseID = async (
  caseInfoId: any,
  searchString: string = "",
): Promise<any> => {
  try {
    const getTeamAPI = api(USER_MGMT_URL);
    const response = await getTeamAPI.get(
      `/api/user/userlookup/getteammembers/by-caseinfoid?caseInfoId=${caseInfoId}&searchString=${searchString}`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching HOD Name:", error);
    throw new Error("Unable to fetch HOD Name. Please try again later.");
  }
};

const getStakeHolderforTeam = async (): Promise<any> => {
  try {
    const getTeamAPI = api(USER_MGMT_URL);
    const response = await getTeamAPI.get(
      `/api/user/userlookup/getstakeholderlist`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching HOD Name:", error);
    throw new Error("Unable to fetch HOD Name. Please try again later.");
  }
};

const getTeamHeaderDetails = async (teamId: any): Promise<any> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.get(
      `/api/team/headerinfo?teamId=${teamId}`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching Team Details:", error);
    throw new Error("Unable to fetch Team Details. Please try again later.");
  }
};

const getStakeHolderDetails = async (teamId: any): Promise<any> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.get(
      `/api/team/stakeholders?teamId=${teamId}`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching Team Details:", error);
    throw new Error("Unable to fetch Team Details. Please try again later.");
  }
};

const getTeamMemberDetails = async (teamId: any): Promise<any> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.get(`/api/team/members?teamId=${teamId}`);
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching Team Details:", error);
    throw new Error("Unable to fetch Team Details. Please try again later.");
  }
};

const addTeamHeaders = async (userData: any): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.post<ApiResponse<any>>(
      "/api/team/add",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again.",
    );
  }
};

const addTeamMembers = async (userData: any): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.post<ApiResponse<any>>(
      "/api/team/member/add",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new team member:", error);
    throw new Error(
      "Failed to add the team member. Please check the data and try again.",
    );
  }
};
const addStakeholderMembers = async (
  userData: any,
): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.post<ApiResponse<any>>(
      "/api/team/stakeholder/add",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new stakeholder:", error);
    throw new Error(
      "Failed to add the stakeholder. Please check the data and try again.",
    );
  }
};

const updateTeamHeaders = async (userData: any): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.put<ApiResponse<any>>(
      "/api/team/update",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again.",
    );
  }
};

const deleteTeamMembers = async (userData: any): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.put<ApiResponse<any>>(
      "/api/team/member/delete",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new stakeholder:", error);
    throw new Error(
      "Failed to add the stakeholder. Please check the data and try again.",
    );
  }
};
const deleteStakeholders = async (userData: any): Promise<ApiResponse<any>> => {
  try {
    const getTeamAPI = api(PICKLIST_URL);
    const response = await getTeamAPI.put<ApiResponse<any>>(
      "/api/team/stakeholder/delete",
      userData,
    );
    const { isSuccess, message, result } = response.data;
    return { isSuccess, message, result };
  } catch (error) {
    console.error("Error adding a new stakeholder:", error);
    throw new Error(
      "Failed to add the stakeholder. Please check the data and try again.",
    );
  }
};

const getRestrictedStakeHolderforTeam = async (): Promise<any> => {
  try {
    const getTeamAPI = api(USER_MGMT_URL);
    const response = await getTeamAPI.get(
      `/api/user/userlookup/get-restricted-stakeholder/list`,
    );
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching HOD Name:", error);
    throw new Error("Unable to fetch HOD Name. Please try again later.");
  }
};

export {
  getTeamsData,
  getHODName,
  getEmployeeNameforTeam,
  getStakeHolderforTeam,
  getTeamHeaderDetails,
  getStakeHolderDetails,
  getTeamMemberDetails,
  addTeamHeaders,
  addTeamMembers,
  addStakeholderMembers,
  updateTeamHeaders,
  deleteTeamMembers,
  deleteStakeholders,
  getRestrictedStakeHolderforTeam,
  getEmployeeNameforTeamByCaseID,
};
